import React, { ReactNode } from 'react';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    padding: '24px 24px 0px 24px',
  },
}));

type Props = {
  children?: ReactNode;
};
export const ModalContent = (props: Props) => {
  const classes = useStyles();
  return <div className={classes.root}>{props.children}</div>;
};
